/**
 * this mixin checks if newsletter or socialMedia links should be shown
 * config found in config/newsletter (client and language based)
 *
 * in template or scripts just use boolean "nacMixin_newsletterAvailable"
 */

import config from 'config/appConfig';

const { newsletter } = config;

const NewsletterAvailableCheck = {
  computed: {
    nacMixin_newsletterAvailable() {
      return newsletter.newsletterAvailableCheckFnc(this.$store.getters.getCurrentLanguage);
    },
    nacMixin_socialMediaAvailable() {
      return newsletter.socialMediaAvailableCheckFnc(this.$store.getters.getCurrentLanguage);
    },
  },
};

export default NewsletterAvailableCheck;
